/**
 * Media blocks — play/pause for videos that opted in via ACF
 *                + tap-to-toggle description on touch / mobile
 */

const TOUCH_QUERY = '(hover: none), (max-width: 1024px)';

function bindDescriptionToggle() {
    const isTouch = window.matchMedia(TOUCH_QUERY).matches;
    if (!isTouch) return;

    document.querySelectorAll('.media-block__item.has-description').forEach((item) => {
        if (item.dataset.descToggleBound) return;
        item.dataset.descToggleBound = 'true';

        item.addEventListener('click', (e) => {
            // Don't toggle when the click was on the play button or the video itself
            if (e.target.closest('.media-block__play, .media-block__video video')) return;
            // If user is interacting with the scrollable description, keep it open
            if (e.target.closest('.media-block__description')) return;

            item.classList.toggle('is-open');
        });
    });

    // Tap outside closes any open card
    document.addEventListener('click', (e) => {
        if (e.target.closest('.media-block__item.has-description')) return;
        document.querySelectorAll('.media-block__item.has-description.is-open').forEach((item) => {
            item.classList.remove('is-open');
        });
    });
}

export function initMediaBlocks() {
    bindDescriptionToggle();

    document.querySelectorAll('.media-block__video.has-player').forEach((wrap) => {
        if (wrap.dataset.playerBound) return;
        wrap.dataset.playerBound = 'true';

        const video = wrap.querySelector('video');
        const btn = wrap.querySelector('.media-block__play');
        if (!video || !btn) return;

        wrap.classList.add('is-paused');

        const play = () => {
            const result = video.play();
            if (result && typeof result.then === 'function') {
                result.catch(() => {});
            }
        };

        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (video.paused) {
                play();
            } else {
                video.pause();
            }
        });

        // Tap the video itself to toggle play / pause
        video.addEventListener('click', () => {
            if (video.paused) {
                play();
            } else {
                video.pause();
            }
        });

        video.addEventListener('play', () => {
            wrap.classList.remove('is-paused');
            btn.classList.add('is-playing');
        });

        video.addEventListener('pause', () => {
            wrap.classList.add('is-paused');
            btn.classList.remove('is-playing');
        });

        video.addEventListener('ended', () => {
            wrap.classList.add('is-paused');
            btn.classList.remove('is-playing');
        });
    });
}
